import axios from 'axios';
import axiosRetry from 'axios-retry';
import { getStoredIdToken, getState } from './auth';
// import { clear } from './storage';
import { v4 as uuidv4 } from 'uuid';
import { CONFIG } from './config';
const TEST_ORGOID = 'G325D695DBFC9G4X';
const TEST_ASSOCIATEOID = 'G5F0A9YBZVH0GKQV';
// Configure retry logic
axiosRetry(axios, {
  retries: 1,
  retryDelay: (retryCount) => retryCount * 1000,
  retryCondition: (error) => {
    return error.response?.status === 504 && 
           error.config?.url?.includes('/chat');
  }
});
// Request interceptor - simplified
axios.interceptors.request.use(
  (config) => {
    // Skip auth headers for auth endpoints
    const authEndpoints = [ '/api/authenticate', '/api/callback', 
                          '/api/id-token', '/api/logout'];
    
                              // Set base URL
    config.baseURL = CONFIG.API_BASE_URL;
    console.log('headless: API Request:', config, config.url);

    // Signal to the local nginx layer that this request originated from the headless SPA/MFEs
    // so it can route /api/* differently than legacy /api/*.
    config.headers = {
      ...(config.headers || {}),
      'X-Headless-Client': '1'
    };

    if (authEndpoints.some(endpoint => config.url?.includes(endpoint))) {
      return config;
    }
    
    // Add headers
    const idToken = getStoredIdToken();
    const state = getState();
    if (idToken) {
      // Authenticated user
      config.headers = {
        ...config.headers,
        'Authorization': `Bearer ${idToken}`,
        'Accept': '*/*',
        'Content-Type': 'application/json',
        'sm_serversessionid': uuidv4(),
        state
      };
    } else {
      config.headers = {
        ...config.headers,
        'Accept': '*/*',
        'Content-Type': 'application/json',
        'sm_serversessionid': uuidv4(),
        ...(state ? { state } : {})
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);
// Response interceptor - simplified
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API request failed:', error);
    // if (error.response?.status === 401) {
    //   console.error('Unauthorized access - redirecting to login');
    //   const redirectUrl = `${CONFIG.POST_LOGIN_REDIRECT_URI}`;
    //   window.location.replace(redirectUrl);
    // }
    return Promise.reject(error);
  }
);
export default axios;
